export const LOAD_DESIGN_REQUEST = 'LOAD_DESIGN_REQUEST';
export const LOAD_DESIGN_SUCCESS = 'LOAD_DESIGN_SUCCESS';
export const LOAD_DESIGN_FAILURE = 'LOAD_DESIGN_FAILURE';

export const UPDATE_DESIGN_REQUEST = 'UPDATE_DESIGN_REQUEST';
export const UPDATE_DESIGN_SUCCESS = 'UPDATE_DESIGN_SUCCESS';
export const UPDATE_DESIGN_FAILURE = 'UPDATE_DESIGN_FAILURE';
export const UPDATE_DESIGN_RESET = 'UPDATE_DESIGN_RESET';
